<template>
  <div class="report-user-content analytics-system-content">
  
      <b-card no-body class="card-analytics-system-content">
        <b-card-header class="statistics-filter-header">
          Filtro
        </b-card-header>
        <b-card-body>
          
          <div class="analytics-system-content-filter">
            <div class="col-md-6">
              <b-form-group>
                <v-select
                  id="origin-list"
                  v-model="originFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  class="form-control-sm"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Origin')"
                  :options="origins"
                  multiple
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group>
                <v-select
                  id="subject-list"
                  v-model="subjectFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  class="form-control-sm"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Subject')"
                  :options="subjects"
                  multiple
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group>
                <v-select
                  id="subject-list"
                  v-model="contentFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  class="form-control-sm"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Content')"
                  :options="contents"
                  multiple
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-form-group>
            </div>

            <div class="col-md-6 user-filter">
              <b-form-group>
                <v-select
                  id="subject-list"
                  v-model="userFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  class="form-control-sm"
                  :placeholder="$t('MANAGE_NEWS_FILTER.User')"
                  :options="users"
                  multiple
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-form-group>
            </div>
            <div class="flex col-md-6 calendar-analytics-system-content">
              <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
              <flat-pickr
                v-model="rangePicker"
                class="form-control-sm form-date"
                :placeholder="$t('MANAGE_NEWS_FILTER.Period')"
                :config="{
                  enableTime: false,
                  dateFormat: 'Y-m-d',
                  altInput: true,
                  altFormat: 'd/m/Y',
                  allowInput: true,
                  mode: 'range',
                }"
              />
            </div>
            
          </div>
          <div class="analytics-system-content-buttons">
            <b-button
              variant="primary"
              size="sm"
              @click="fetchData()"
            >
            <feather-icon icon="SearchIcon" class="export-button-icon"/>
              {{ $t("MANAGE_NEWS_FILTER.Search") }}
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="fetchDataDay()"
            >
              Mais Lidas - Dia
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="fetchDataWeek()"
            >
              Mais Lidas - Semana
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="fetchDataMonth()"
            >
              Mais Lidas - Mês
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="reportData()"
            >
              <feather-icon icon="FileTextIcon" class="export-button-icon"/>
              Exportar
            </b-button>
            <b-button 
              variant="primary"
              size="sm" 
              @click="onClear"
            >
              <feather-icon icon="TrashIcon" class="export-button-icon"/>
              {{ $t('MANAGE_NEWS_FILTER.Clear') }}
            </b-button>
          </div>
          <div class="analytics-system-content-buttons">
            
          </div>
          
        </b-card-body>
        
      </b-card>
      <div v-if="listData" class="analytics-system-content-body">
        <vue-perfect-scrollbar
          class="report-user-scroll-area"
          :suppressScrollX="true"
        >
          <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
            <div v-if="listData && listData.length > 0">
              <app-collapse
                accordion
                type="margin"
                not-arrow
              >
                <app-collapse-item
                  title="" 
                  v-for="(item, index) in filteredListData" 
                  :key="index"
                >
                  <div 
                    slot="header" 
                    class="d-flex justify-content-between align-items-center"
                    @click="toggleCard(index)"
                  >
                    {{ item.content }}
                    <span >
                      <feather-icon :icon="getChevronIcon(index)" size="18"/>
                    </span>
                  </div>
                  <div>
                    <b-row>
                      <b-col md="3"><b>Título</b></b-col>
                      <b-col md="2"><b>N° de visualizações</b></b-col>
                      <b-col md="2"><b>Assunto</b></b-col>
                      <b-col md="2"><b>Autor</b></b-col>
                      <b-col md="2"><b>Data de Publicação</b></b-col>
                    </b-row>
                    <hr>
                    <b-row 
                      v-for="(news, index) in item.news" 
                      :key="index" class="config-email-row" 
                      :style="{ 'border-bottom': '1px solid rgba(221, 221, 221, 0.2)', 'margin-bottom': '10px', 'padding-bottom': '10px' }"
                    >
                      <b-col md="3" >{{news.title}}</b-col>
                      <b-col md="2">{{news.read}}</b-col>
                      <b-col md="2">{{news.subjects}}</b-col>
                      <b-col md="2">{{news.author}}</b-col>
                      <b-col md="2">{{ getDateFormat(news.dt_publish) }}</b-col>
                    </b-row>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </div>
            <div v-else>
              Nenhum registro encontrado
            </div>
          </b-overlay>
        </vue-perfect-scrollbar>
      </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  // BBadge,
  BFormGroup,
  // BCardTitle,
  BButton,
  BOverlay,
  BRow,
  BCol
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import newsReportService from "@/providers/newsReportService";
import { ref } from "@vue/composition-api";
import dropdownService from "@/providers/dropdownService";
// import AppConstants from "@/appConstants";
import vSelect from "vue-select";
// import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import { formatDate } from "@core/utils/filter";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import flatPickr from "vue-flatpickr-component";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    VuePerfectScrollbar,
    BCardHeader,
    BCard,
    // BBadge,
    BCardBody,
    flatPickr,
    BFormGroup,
    vSelect,
    // BCardTitle,
    BButton,
    BOverlay,
    BRow,
    BCol
  },
  data() {
    return {
      openItems: {}
    };
  },
  computed: {
    filteredListData() {
      return this.listData.map(item => ({
        ...item,
        news: item.news.filter(news => news.read > 0),
      }));
    },
  },
  watch: {
  },
  methods: {
    toggleCard(index) {
      this.$set(this.openItems, index, !this.openItems[index]);
    },
    getChevronIcon(index) {
      return this.openItems[index] ? 'ChevronUpIcon' : 'ChevronDownIcon';
    }
  },
  setup() {
    const displayOverlay = ref(false);
    // const rangePicker = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    const rangePicker = ref("");
    const origins = ref([]);
    const subjects = ref([]);
    const contents = ref([]);
    const users = ref([]);

    const originFilter = ref([]);
    const subjectFilter = ref([]);
    const contentFilter = ref([]);
    const userFilter = ref([]);

    const listData = ref([]);

    // const limit = AppConstants.PAGINATOR_DEFAULT_LIMIT;
    const limit = ref(50);
    // const page = 1;

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };

    const fetchFilter = () => {
      const originParams = new URLSearchParams();
      originParams.append('code', 250);
      const subjectParams = new URLSearchParams();

      dropdownService.getAllOrigin(originParams).then(res => {
        origins.value = res;
        originFilter.value = res;
        subjectParams.append('origins', originFilter.value.map((item) => item.id).join(","));
        Promise.all([
          dropdownService.getAllSubjects(subjectParams),
          dropdownService.getContent(subjectParams),
          dropdownService.getUsers(new URLSearchParams()),
        ]).then((resp) => {
          subjects.value = resp[0];
          contents.value = resp[1];
          users.value = resp[2];
        });

      })

    };

    const buildParams = () => {
      const params = new URLSearchParams();
      if (originFilter.value) {
        params.append(
          "source",
          originFilter.value.map((item) => item.id).join(",")
        );
      }
      if (userFilter.value.length > 0) {
        params.append(
          "users",
          userFilter.value.map((item) => item.id).join(",")
        );
      }
      if (subjectFilter.value) {
        params.append(
          "subject",
          subjectFilter.value.map((item) => item.id).join(",")
        );
      }
      if (contentFilter.value) {
        params.append(
          "content",
          contentFilter.value.map((item) => item.id).join(",")
        );
      }
      
      return params;
    };
    const getDateFormat = (dt) => {
      return formatDate(dt, {
        dateStyle: "short",
        timeStyle: "short",
      });
    };

    const formatDateButtom = (date) => {
      return date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
    };

    const getCurrentDate = () => {
      const today = new Date();
      return formatDateButtom(today);
    };

    const getLastWeekRange = () => {
      const end = new Date();
      const start = new Date(end);
      start.setDate(start.getDate() - 7);
      return `${formatDateButtom(start)} até ${formatDateButtom(end)}`;
    };

    const getLastMonthRange = () => {
      const end = new Date();
      const start = new Date(end);
      start.setDate(start.getDate() - 30);
      return `${formatDateButtom(start)} até ${formatDateButtom(end)}`;
    };

    const fetchDataDay = () => {
      displayOverlay.value = true;
      const params = buildParams();
      params.append('limit', limit.value);
      rangePicker.value = getCurrentDate()
      params.append("dt_range", rangePicker.value);
      newsReportService.getControlContentView(params).then((resp) => {
        listData.value = resp;
        displayOverlay.value = false;
      });
    };

    const fetchDataWeek = () => {
      displayOverlay.value = true
      const params = buildParams();
      params.append('limit', limit.value);
      rangePicker.value = getLastWeekRange()
      params.append("dt_range", rangePicker.value);
      newsReportService.getControlContentView(params).then((resp) => {
        listData.value = resp;
        displayOverlay.value = false;
      });
    };

    const fetchDataMonth = () => {
      displayOverlay.value = true;
      const params = buildParams();
      params.append('limit', limit.value);
      rangePicker.value = getLastMonthRange()
      params.append("dt_range", rangePicker.value);
      newsReportService.getControlContentView(params).then((resp) => {
        listData.value = resp;
        displayOverlay.value = false;
      });
    };

    const fetchData = () => {
      displayOverlay.value = true
      const params = buildParams();
      params.append('limit', limit.value);
      params.append("dt_range", rangePicker.value);
      newsReportService.getControlContentView(params)
      .then((resp) => {
        listData.value = resp;
        displayOverlay.value = false
      }).catch(err => console.error(err))
      .finally(() => {
        displayOverlay.value = false;
      });
    };

    const reportData = () => {
      displayOverlay.value = true
      const params = buildParams();
      // params.append('page', page);
      // params.append('limit', limit);
      params.append('limit', limit.value);
      
      if (rangePicker.value) {
        params.append("dt_range", rangePicker.value);
      }
      if (!rangePicker.value || rangePicker.value <= 0) {
        messagesNotifyHelper.errorNotify(
          "Erro",
          "Sem dados para exportar, verifique sua pesquisa e tente novamente"
        );
        displayOverlay.value = false;
        return;
      }
      params.append("download", true);
      newsReportService
        .reportControlContentView(params)
        .then((response) => {
          displayOverlay.value = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'estatistica-assunto-conteudo.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch(err => console.error(err))
        .finally(() => {
          displayOverlay.value = false;
        });
    };

    const onClear= () => {
      rangePicker.value = "";
      originFilter.value = [];
      subjectFilter.value = [];
      contentFilter.value = [];
      userFilter.value = [];
    };

    fetchFilter();

    return {
      // variables
      displayOverlay,
      perfectScrollbarSettings,
      rangePicker,
      origins,
      subjects,
      contents,
      users,

      originFilter,
      subjectFilter,
      contentFilter,
      userFilter,
      listData,

      // methods
      getDateFormat,
      fetchData,
      formatDate,
      reportData,
      onClear,
      fetchDataDay,
      fetchDataWeek,
      fetchDataMonth,
      // formatDate
    };
  },
};
</script>

<style>

.analytics-system-content .calendar-analytics-system-content {
  /* margin-bottom: 15px; */
  padding-left: 25px;
  padding-right: 25px;
}

.calendar-analytics-system-content .form-control-sm {
  height: 100%;
}

.analytics-system-content-buttons {
  padding: .5rem;
}

.analytics-system-content-buttons button {
  margin-right: 10px;
}

.analytics-system-content-body {
  padding: 15px;
  height: 100%;
  max-height: 65%;
}

.analytics-system-content-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.analytics-system-content-body span {
  margin-left: 15px;
}


</style>
